import React, {useRef, useState} from 'react';
import {Button, Input, Space} from 'antd';
import {SearchOutlined} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import {FilterConfirmProps} from 'antd/es/table/interface';

interface DataIndex {
    [key: string]: any;
}

const TableSearchComp = (dataIndex: keyof Record<any, any>, columnName: string) => {
    const [searchText, setSearchText] = useState<string>('');
    const [searchedColumn, setSearchedColumn] = useState<DataIndex>({});
    const searchInput = useRef<any>(null);

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const formatNumber = (input: string) => {
        const isDate = !isNaN(Date.parse(input));
        if (isDate) {
            return input;
        }

        const withoutCommas = input.replace(/,/g, '');
        const parsedNumber = parseFloat(withoutCommas);

        if (isNaN(parsedNumber)) {
            return input;
        }

        const result = parsedNumber.toString();
        return result;
    }

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
        setSearchedColumn(dataIndex);
    };

    return {
        filterDropdown: ({
                             setSelectedKeys,
                             selectedKeys,
                             confirm,
                             clearFilters,
                             close
                         }: {
            setSelectedKeys: any;
            selectedKeys: any;
            confirm: any;
            clearFilters: any;
            close: any;
        }) => (
            <div style={{padding: 8}} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${columnName}`}
                    value={selectedKeys[0]}
                    onChange={(e: { target: { value: React.Key } }) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm)}
                    style={{marginBottom: 8, display: 'block'}}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{width: 90}}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                    <Button type="link" size="small" onClick={() => close()}>
                        Close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{color: filtered ? '#1677ff' : undefined}}/>
        ),
        onFilter: (value: any, record: any) => {
            const dataIndexValue = record[dataIndex];

            value = formatNumber(value)
            if (dataIndexValue !== undefined && dataIndexValue !== null) {
                return dataIndexValue
                    .toString()
                    .toLowerCase()
                    .includes((value as string).toLowerCase());
            }
            return false;
        },
        onFilterDropdownOpenChange: (visible: any) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text: any) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            )
    };
};

export default TableSearchComp;
